import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import { useToggleCatalogLockDefaultModel } from '@webapp/modules/purchasing/features/toggle-catalog-lock-default/models'
import messages from './messages'

interface UseToggleCatalogLockDefaultPresenterOptions {
  checked: boolean
  onChange?: (serverValue: boolean) => void
}

export const useToggleCatalogLockDefaultPresenter = ({
  checked,
  onChange,
}: UseToggleCatalogLockDefaultPresenterOptions) => {
  const { setCatalogLockDefault, isLoading } =
    useToggleCatalogLockDefaultModel()
  const intl = useProcurifyIntl()

  const toggle = async (value: boolean): Promise<void> => {
    // Optimistic: the controlled Toggle should move on click, not after the
    // save round-trips. `checked` in this closure is the pre-flip value, so
    // the catch below reverts to it on a failed save.
    onChange?.(value)

    try {
      const serverValue = await setCatalogLockDefault(value)

      onChange?.(serverValue)

      toast.success({
        title: intl.formatMessage(messages.successTitle),
        children: intl.formatMessage(messages.successMessage),
      })
    } catch (error) {
      onChange?.(checked)

      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children:
          getMessageFromError(error) ||
          intl.formatMessage(messages.errorMessage),
      })
    }
  }

  return {
    commands: {
      toggle,
    },
    states: {
      isSaving: isLoading,
    },
  }
}
